export enum BUSINESS_CODE {
  ADMIN = 0,
  VEICULOS = 1,
  SIM = 2,
}
